import React from 'react';
import styled from 'styled-components';
import { Field, FieldAttributes, FieldProps } from 'formik';
import _get from 'lodash/get';
import { setFieldValueAndTouched, withErrorMessage } from '@minecraft.utils';
import UncontrolledTextarea from '@minecraft.uncontrolled-textarea';

/** Styled Components */
const StyledLabel = styled.label`
  line-height: 1.25rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: ${(props): string => props.theme.colors.primary.darkGrey};
`;

const Textarea = ({ form, field, onChange, onChangeProp, showLabel, label, ...restProps }): JSX.Element => (
  <>
    {showLabel && label && <StyledLabel htmlFor={field.name}>{label}</StyledLabel>}
    <UncontrolledTextarea
      id={field.name}
      defaultValue={_get(form.values, field.name)}
      onChange={(e) => {
        setFieldValueAndTouched(field.name, e.target.value, form);
        onChangeProp?.();
      }}
      {...restProps}
    />
  </>
);

type Props = {
  name: string;
  maxLength?: number;
} & Record<string, any>;

/**
 * @deprecated This is an older component that does not use our standard form wrapper
 * to match the design system.
 *
 * instead use the TextAreaInput
 * import { TextAreaInput } from '@minecraft.molecules'
 *
 * <TextAreaInput name="fieldName" label="Field Label" />
 */
const FormikTextarea = ({ onChange, ...props }: FieldAttributes<Props>): JSX.Element => (
  <Field {...props}>
    {(fieldProps: FieldProps) => withErrorMessage(Textarea)({ ...props, onChangeProp: onChange, ...fieldProps })}
  </Field>
);

export default FormikTextarea;
